<div class="tab-pane active container-fluid" role="tabpanel" aria-labelledby="germplasm-list-data-tab">
	<div class="col">
		<div class="row"></div>
		<jhi-variable-container [title]="title | translate" [selectedVariables]="selectedVariables" [variables]="variables" [hideAddAndRemove]="this.germplasmList?.locked" (onAddVariable)="addVariable($event)" (onDeleteVariable)="deleteVariables($event)"></jhi-variable-container>
	</div>
	<div class="row pt-4">
		<div class="col d-flex align-items-center justify-content-end">
                <div ngbDropdown class="dropdown" placement="bottom-right">
                <!-- Dropdown trigger button -->
                <button ngbDropdownToggle class="btn btn-info float-end" type="button" id="mainActions"
                        data-bs-toggle="dropdown" aria-expanded="false">
                    <span jhiTranslate="actions"></span>
                </button>

                <!-- Dropdown menu -->
                <ul ngbDropdownMenu class="dropdown-menu dropdown-menu-end" aria-labelledby="mainActions">
                    <!-- Import List Update -->
                    <li [hidden]="this.germplasmList?.locked" *jhiHasAnyAuthority="IMPORT_GERMPLASM_LIST_UPDATES_PERMISSION">
                        <a class="dropdown-item" [routerLink]="['/', { outlets: { popup: 'germplasm-list-import-update'} }]"
                           [replaceUrl]="true" queryParamsHandling="merge" data-test="importListButton">
                            <span jhiTranslate="germplasm-list.actions.import-list.update"></span>
                        </a>
                    </li>

                    <!-- Reorder Entries -->
                    <li [hidden]="this.germplasmList?.locked" *jhiHasAnyAuthority="REORDER_ENTRIES_GERMPLASM_LISTS_PERMISSIONS">
                        <button class="dropdown-item" (click)="openReorderEntries()" data-test="reorderEntriesButton">
                            <span jhiTranslate="germplasm-list.list-data.actions.reorder-entries"></span>
                        </button>
                    </li>

                    <!-- Remove Entries -->
                    <li [hidden]="this.germplasmList?.locked" *jhiHasAnyAuthority="REMOVE_ENTRIES_GERMPLASM_LISTS_PERMISSIONS">
                        <button class="dropdown-item" (click)="removeEntries()" data-test="removeEntriesButton">
                            <span jhiTranslate="germplasm-list.list-data.actions.remove-entries"></span>
                        </button>
                    </li>

                    <!-- Add Entries -->
                    <li [hidden]="this.germplasmList?.locked" *jhiHasAnyAuthority="ADD_GERMPLASM_LIST_ENTRIES_PERMISSIONS">
                        <button class="dropdown-item" (click)="openGermplasmSelectorModal()" data-test="addEntriesButton">
                            <span jhiTranslate="germplasm-list.list-data.actions.add-entries"></span>
                        </button>
                    </li>

                    <!-- Add to List -->
                    <li *jhiHasAnyAuthority="ADD_ENTRIES_TO_LIST_PERMISSIONS">
                        <button class="dropdown-item" (click)="openAddToList()" data-test="addToListButton">
                            <span jhiTranslate="germplasm-list.list-data.actions.add-entries-to-another"></span>
                        </button>
                    </li>

                    <!-- Delete List -->
                    <li *ngIf="isDeleteActionItemAvailable()">
                        <button class="dropdown-item" (click)="deleteList()" data-test="deleteListButton">
                            <span jhiTranslate="germplasm-list.list-data.actions.delete-list"></span>
                        </button>
                    </li>

                    <!-- Clone List -->
                    <li *jhiHasAnyAuthority="CLONE_GERMPLASM_LIST_PERMISSIONS">
                        <button class="dropdown-item" (click)="openCloneGermplasmList()" data-test="cloneListButton">
                            <span jhiTranslate="germplasm-list.list-data.actions.clone-list"></span>
                        </button>
                    </li>

                    <!-- Move to Folder -->
                    <li [hidden]="this.germplasmList?.locked" *jhiHasAnyAuthority="EDIT_LIST_METADATA_PERMISSIONS">
                        <button class="dropdown-item" (click)="moveToFolder()" data-test="moveToFolderButton">
                            <span jhiTranslate="germplasm-list.list-data.actions.move-to-folder"></span>
                        </button>
                    </li>

                    <!-- Export Data and Labels -->
                    <li *jhiHasAnyAuthority="GERMPLASM_LIST_LABEL_PRINTING_PERMISSIONS">
                        <button class="dropdown-item" (click)="exportDataAndLabels()" data-test="exportListButton">
                            <span jhiTranslate="germplasm-list.list-data.actions.export-data-and-labels"></span>
                        </button>
                    </li>

                    <!-- COP -->
                    <li *jhiHasAnyAuthority="VIEW_PEDIGREE_INFORMATION_PERMISSION">
                        <button class="dropdown-item" (click)="calculateCop(true)">
                            <span jhiTranslate="germplasm-list.list-data.actions.cop.menu"></span>
                        </button>
                    </li>
                </ul>
            </div>
				<jhi-list-columns *ngIf="!this.germplasmList?.locked" class="ms-2 float-end"
								  [listId]="this.listId"
								  (columnsSelectedEvent)="onColumnsSelected($event)">
				</jhi-list-columns>

		</div>
	</div>
	<div class="row mt-2 mb-2">
		<div class="col">
			<div style="float: right">
				<button class="btn btn-light" [hidden]="this.germplasmList?.locked"
						*jhiHasAnyAuthority="EDIT_LIST_METADATA_PERMISSIONS"
						(click)="openEditListMetadata()"
						data-test="editListMetadataButton">
					<i [ngClass]="'fa fa-edit'"></i>
				</button>
				<button class="btn btn-light" (click)="toggleListStatus()" [disabled]="!(principal.hasAnyAuthorityDirect(LOCK_UNLOCK_PERMISSIONS) || user?.id === germplasmList?.ownerId)" data-test="lockListButton">
					<i [ngClass]="germplasmList?.locked ? 'fa fa-lock': 'fa fa-unlock'" aria-hidden="true" data-test="lockListIcon"></i>
				</button>
			</div>
			<div class="mb-3 d-flex align-items-center">
				<jhi-item-count-custom [page]="page" [total]="totalItems" [itemsPerPage]="itemsPerPage"></jhi-item-count-custom>
				<span style="margin-left: 20px;">{{ 'common.selected' | translate}}</span>
				<span style="padding-left: 5px;" class="fw-bold">
					{{this.size()}}
				</span>
				<div class="form-check form-check-inline" style="margin-left: 20px;">
					<input type="checkbox" class="form-check-input" [ngbTooltip]="'global.select.all' | translate" [checked]="isSelectAll" (click)="onSelectAll(isSelectAll)" id="check-select-all" name="check-select-all">
					<label class="form-check-label" for="check-select-all" style="padding-left: 5px;" jhiTranslate="global.select.all">
						Select all pages
					</label>
				</div>
				<div class="ms-2">
					<button class="btn btn-outline-info btn-sm" href (click)="onClearSort($event)" jhiTranslate="global.clear-sort"></button>
				</div>
				<span *ngIf="isLoading" style="margin-left: 10px;" class="throbber"></span>
			</div>
		</div>
	</div>

	<div class="table-responsive" *ngIf="entries">
		<table class="table table-striped table-bordered table-curved" data-test="germplasmListTable">
			<thead>
			<tr jhiSort [(predicate)]="predicate" [(ascending)]="isAscending" [callback]="this.transition.bind(this)">
				<th *ngIf="!isSelectAll" class="non-editable"><input type="checkbox" class="form-check-input" [ngbTooltip]="'global.select.current.page' | translate" [checked]="isPageSelected()" (click)="onSelectPage()" [title]="'global.select.current.page' | translate" data-test="selectCurrentPageCheckbox"></th>
				<th *ngFor="let column of header" [ngClass]="{'non-editable': isNotEditableColumn(column)}">
					<span *ngIf="isColumnSortable(column)" jhiSortBy="{{this.getColumnSortName(column)}}">
                        @if (getStaticColumnLabelKey(column.termId)) {
                            {{getStaticColumnLabelKey(column.termId) | translate}}
                        } @else {
                            <span>{{this.getHeaderDisplayName(column)}}</span>
                            <span class="fa fa-sort"></span>
                        }
					</span>
					<span *ngIf="!isColumnSortable(column)">
						  @if (getStaticColumnLabelKey(column.termId)) {
                              {{getStaticColumnLabelKey(column.termId) | translate}}
                          } @else {
                              <span>{{this.getHeaderDisplayName(column)}}</span>
                          }
						<span *ngIf="column.termId === TermIdEnum.CROSS && !this.germplasmList?.locked">
							<!-- TODO [title] with translation not resolving correctly when opening from my-lists -->
							<i class="fa fa-edit ms-2" role="button" title="{{ 'germplasm-list.fill.with.cross.expansion' | translate }}"
							   [ngbPopover]="crossOptionsPopover" [placement]="['bottom', 'left']" [autoClose]="'outside'"
							   data-test="specifyExpansionLevelButton"
							></i>
						</span>
					</span>
					<jhi-column-filter-inline *ngIf="isColumnFilterable(column)" [filter]="this.getFilter(column)"
											  (onApply)="this.applyFilters()"
											  (onReset)="this.resetFilters()"></jhi-column-filter-inline>
				</th>
			</tr>
			</thead>
			<tbody *ngIf="entries.length else nodata" cdkDropList cdkDropListConnectedTo="listBuilderDrop">
			<tr *ngFor="let entry of entries; index as index; trackBy: trackByEntry"
                (click)="toggleSelect($event, index, entry); $event.stopPropagation()"
                (mousedown)="preventDefaultOnShiftKey($event)"
                [class.selected]="isSelected(entry)"
				cdkDrag [cdkDragDisabled]="!listBuilderContext.visible" (cdkDragEntered)="dragStart($event, entry)">
				<td *ngIf="!isSelectAll"><input type="checkbox" class="form-check-input" [checked]="isSelected(entry)" (click)="toggleSelect($event, index, entry, true); $event.stopPropagation()"></td>
				<td *ngFor="let column of header">
					<jhi-list-data-row [germplasmList]="germplasmList" [listId]="listId" [column]="column" [entry]="entry"></jhi-list-data-row>
				</td>
			</tr>
			</tbody>
		</table>
		<ng-template #nodata>
			<tbody>
			<tr>
				<td [attr.colspan]="(this.header.length)+1" jhiTranslate="no.data"></td>
			</tr>
			</tbody>
		</ng-template>
	</div>
	<div *ngIf="entries && entries.length">
		<div class="row">
			<div class="col">
				<div class="pagination-container">
					<div class="pagination-box pagination-box-left">
						<div>
							<jhi-item-count-custom [page]="page" [total]="totalItems" [itemsPerPage]="itemsPerPage"></jhi-item-count-custom>
						</div>
					</div>
					<div class="pagination-box">
						<ngb-pagination [collectionSize]="totalItems" [(page)]="page" [pageSize]="itemsPerPage" [disabled]="isLoading"
										[maxSize]="5" [rotate]="true" [boundaryLinks]="true" (pageChange)="loadPage(page)"></ngb-pagination>
					</div>
					<div class="pagination-box pagination-box-right">
						<div class="d-flex align-items-center">
							<label for="itemsPerPage" class="control-label control-label-left" jhiTranslate="global.items.per.page"></label>
							<select [(ngModel)]="itemsPerPage" class="form-select ms-2" id="itemsPerPage" [disabled]="isLoading" (change)="resetTable();" style="width:95px">
								<option value="20">20</option>
								<option value="50">50</option>
								<option value="75">75</option>
								<option value="100">100</option>
							</select>
						</div>
					</div>
				</div>
			</div>
		</div>
	</div>
</div>
<ng-template #crossOptionsPopover>
	<form>
		<div class="mb-3">
			<label for="generationLevel" class="fw-bold" jhiTranslate="germplasm-list.list-data.cross.generation.level.label"></label>
			<select class="form-select" id="generationLevel" name="generationLevel" [(ngModel)]="generationLevel">
				<option *ngFor="let level of generationLevels" [value]="level">{{level}}</option>
			</select>
		</div>
		<div class="footer text-center"><br>
			<button type="submit" class="btn btn-primary btn-sm" jhiTranslate="apply"
					data-test="crossExpansionApplyButton"
					[disabled]="isLoading"
					(click)="fillWithCrossExpansion()"></button>
		</div>
	</form>
</ng-template>
